"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordGuidelines = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var defaultPasswordRules = [
    {
        text: '10 characters',
        condition: function (password) { return password.length > 9; },
        shouldRunCondition: function (password) { return password.length > 1; }
    },
    {
        text: '1 capital letter',
        condition: function (password) { return /[A-Z]/.test(password); },
        shouldRunCondition: function (password) { return password.length > 1; },
    },
    {
        text: '1 number',
        condition: function (password) { return /\d/.test(password); },
        shouldRunCondition: function (password) { return password.length > 1; },
    },
    {
        text: '1 special character',
        condition: function (password) { return /[!@#$%^&*(),.?":{}|<>]/.test(password); },
        shouldRunCondition: function (password) { return password.length > 1; },
    }
];
var defaultColors = {
    error: theme_1.colors.error,
    normal: theme_1.colors.white,
    success: theme_1.colors.success,
};
var PasswordGuidelines = /** @class */ (function (_super) {
    __extends(PasswordGuidelines, _super);
    function PasswordGuidelines() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.guidelinesHeaderText = 'Password must contain at least';
        _this.passwordConfirmationText = 'Passwords Must Match';
        return _this;
    }
    PasswordGuidelines.prototype.render = function () {
        var _a = this.props, _b = _a.colors, colors = _b === void 0 ? defaultColors : _b, _c = _a.confirmation, confirmation = _c === void 0 ? '' : _c, _d = _a.password, password = _d === void 0 ? '' : _d, _e = _a.passwordRules, passwordRules = _e === void 0 ? defaultPasswordRules : _e, _f = _a.validatePasswordConfirmation, validatePasswordConfirmation = _f === void 0 ? false : _f, _g = _a.shouldValidate, shouldValidate = _g === void 0 ? false : _g, _h = _a.style, style = _h === void 0 ? {} : _h;
        return (React.createElement("div", { style: style },
            React.createElement("span", null,
                this.guidelinesHeaderText,
                ":"),
            React.createElement("br", null),
            passwordRules.map(function (rule, index) { return (React.createElement(Guideline, { key: index, shouldValidate: shouldValidate, password: password, rule: rule, colors: colors },
                "* ",
                rule.text,
                React.createElement("br", null))); }),
            validatePasswordConfirmation &&
                React.createElement(ConfirmationGuideline, { colors: colors, confirmation: confirmation, password: password },
                    "* ",
                    this.passwordConfirmationText)));
    };
    return PasswordGuidelines;
}(React.Component));
exports.PasswordGuidelines = PasswordGuidelines;
var ConfirmationGuideline = styled_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: stretch;\n  color: ", ";\n"], ["\n  align-items: stretch;\n  color: ", ";\n"])), getConfirmationColor);
function getConfirmationColor(_a) {
    var colors = _a.colors, confirmation = _a.confirmation, password = _a.password;
    if (confirmation.length < 7) {
        return colors.normal;
    }
    if (confirmation !== password) {
        return colors.error;
    }
    return colors.success;
}
var Guideline = styled_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: stretch;\n  color: ", ";\n"], ["\n  align-items: stretch;\n  color: ", ";\n"])), getTextColor);
function getTextColor(_a) {
    var shouldValidate = _a.shouldValidate, colors = _a.colors, password = _a.password, rule = _a.rule;
    if (!shouldValidate) {
        return colors.normal;
    }
    if (!rule.shouldRunCondition(password)) {
        return colors.normal;
    }
    if (!rule.condition(password)) {
        return colors.error;
    }
    return colors.success;
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map